function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import ReactConfigContext from '../../ReactConfigContext';
import { Body, CallToAction, Heading } from '../../atoms';
import { ArrowRight } from '../../visuals';
export default function ImageActionCard(param) {
    var image = param.image, title = param.title, description = param.description, actions = param.actions, className = param.className;
    var _useContext = useContext(ReactConfigContext), ImageComponent = _useContext.config.ImageComponent;
    return /*#__PURE__*/ React.createElement("article", {
        className: twMerge('grid grid-cols-1 grid-rows-[auto_1fr]', className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-rows-1 w-full h-[22rem]"
    }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread_props(_object_spread({}, image), {
        className: twMerge('w-full h-full object-cover object-center rounded-t-md safari-fix-transform', image.className)
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "h-full bg-bg-subtle p-5 rounded-b-md md:p-6 lg:p-9"
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: "h3"
    }, title), !!description && /*#__PURE__*/ React.createElement(Body, {
        variant: "default",
        className: "mt-3 md:mt-6"
    }, description), !!(actions === null || actions === void 0 ? void 0 : actions.length) && /*#__PURE__*/ React.createElement("div", {
        className: "mt-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap -m-2"
    }, actions.map(function(action) {
        return /*#__PURE__*/ React.createElement(CallToAction, _object_spread_props(_object_spread({
            key: action.href
        }, action), {
            className: twMerge('m-2 w-full md:w-auto', action.className),
            buttonType: "icon-after",
            icon: /*#__PURE__*/ React.createElement(ArrowRight, null)
        }));
    })))));
}

//# sourceMappingURL=ImageActionCard.js.map